import React from 'react';

function PeopleSegmentation() {
  return (
    <div className="container-fluid mt-4">
      <div className="text-center mb-4">
        <img
          src="/assets/images/projects/people_segmentation/image1_700x300.svg"
          alt="People Segmentation Banner"
          className="img-fluid rounded shadow"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
      <h2 className="mb-4">
        <i className="fas fa-user-circle text-warning"></i> People Segmentation (MobileNetV2 + U-Net)
      </h2>
      <div className="alert alert-info">
        <i className="fas fa-info-circle"></i> Segmentación semántica de retratos y parsing facial con <strong>MobileNetV2 + U-Net</strong>.
        9 clases (piel, cejas, ojos, labios, dientes). Mean Dice: 0.757.
      </div>
      <div className="embed-responsive" style={{ height: '80vh' }}>
        <iframe
          src="http://www.cloudsapps.net:8504/"
          title="People Segmentation"
          className="embed-responsive-item w-100 h-100"
          style={{ border: '1px solid #ddd', borderRadius: '8px' }}
          allow="accelerometer; camera; microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        />
      </div>
    </div>
  );
}

export default PeopleSegmentation;
